"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// multipleScriptsForm
exports.default = ({ langId, autoSaveHandler, }) => {
    return {
        schemaType: "object",
        properties: [
            ...(langId
                ? [
                    {
                        title: "ステータス変更",
                        propertyName: `translationStatus.${langId}`,
                        schema: {
                            schemaType: "selector",
                            options: [
                                {
                                    value: null,
                                    title: "未着手",
                                },
                                {
                                    value: "translated",
                                    title: "翻訳済み",
                                },
                                {
                                    value: "corrected",
                                    title: "校閲済み",
                                },
                            ],
                            autoSaveHandler: autoSaveHandler,
                        },
                    },
                    {
                        title: "参照訳に利用",
                        tooltip: "このテキストを参照訳として利用します",
                        propertyName: `translationIgnore.${langId}`,
                        schema: {
                            schemaType: "boolean",
                            invert: true,
                            autoSaveHandler: autoSaveHandler,
                        },
                    },
                ]
                : [
                    {
                        title: "翻訳文",
                        propertyName: `message`,
                        schema: {
                            schemaType: "message",
                            text: "言語を選択してください",
                        },
                    },
                ]),
            {
                title: "単語登録",
                tooltip: "この単語が含まれている文章は、常にこの単語を参照訳として利用します。通常の参照訳は、相対的に一致度の高いものだけが利用されます",
                propertyName: `shouldIncludedIntoSegmentLevelWordTable`,
                schema: {
                    schemaType: "boolean",
                    autoSaveHandler: autoSaveHandler,
                },
            },
        ],
    };
};
